import React, { Component } from 'react';
import { Modal } from 'reactstrap';

class ShowModalVideo extends Component {

    render() {
        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
                style={{ maxWidth: "794px" }}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-video"></i></span>
                    <h5>Video de explicación</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="rk-modal__body">
                    <div className="row">
                        <div className="col-md-12">
                            <iframe width="760" height="425" src={`${this.props.video_url}`} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>

                <div className="rk-modal__footer">
                    <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                        Cerrar
                    </button>
                </div>
            </Modal>
        );
    }
}

export default ShowModalVideo;
